<template>
  <div class="grid grid-cols-[minmax(30px,150px)_1fr] gap-4 items-center mt-8">
    <FormLabel label="Type">
      <FormKit
        :options="POP_UP_CARDS_TYPE_OPTIONS"
        name="popupCardType"
        placeholder="Choose a type"
        type="select"
      />
    </FormLabel>
    <FormLabel label="QTY">
      <FormKit name="popupCardQty" type="text" />
    </FormLabel>
    <FormLabel label="Cost">
      <FormKit name="popupCardPrice" type="text" />
    </FormLabel>
    <DiscountField
      :values="values"
      checkboxName="popupCardDiscount"
      priceName="popupCardDiscountPrice"
      priceTypeName="popupCardDiscountType"
    />
  </div>
</template>
<script setup>
import DiscountField from "@/components/Order/DiscountField/DiscountField.vue";
import { POP_UP_CARDS_TYPE_OPTIONS } from "@/consts/newOrderFormInputs";
import { toRefs } from "vue";
import FormLabel from "../../../UI/Form/FormLabel.vue";

const props = defineProps({
  values: {
    type: Object,
    default: () => ({}),
  },
});

const { values } = toRefs(props);
</script>
